import React, { FC, PropsWithChildren } from "react";
import { TextStyle } from "./text.style";

export const Text: FC<PropsWithChildren> = (props) => {
    return <TextStyle>{props.children}</TextStyle>
};
